import MarkdownIt from 'markdown-it'

export const useMarkdown = () => {
    const md = new MarkdownIt({
        html: true,        // Включаем HTML
        breaks: true,      // Переносы строк
        linkify: true      // Автоматическое определение ссылок
    })

    const parseMarkdown = (content: string) => {
        if (!content) return ''
        return md.render(content)
    }

    return {
        parseMarkdown
    }
}